<template>
    <footer class="relative overflow-hidden mt-12">
        <div class="w-full max-w-7xl mx-auto px-6 py-10">
            <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
                <div class="col-span-full lg:col-span-1">
                    <Brand :appName="appName" />
                </div>
                <div class="col-span-2 lg:col-span-1">
                    <h4 class="text-xs font-semibold text-gray-900 uppercase">
                        Features
                    </h4>

                    <div class="mt-3 grid space-y-3 text-sm">
                        <p>
                            <a
                                class="inline-flex gap-x-2 text-gray-600 hover:text-gray-800"
                                :href="marketingPageUrls.flexibleAvailability"
                            >
                                Flexible Availability
                            </a>
                        </p>
                    </div>
                </div>
                <div class="col-span-2 lg:col-span-1">
                    <h4 class="text-xs font-semibold text-gray-900 uppercase">
                        Company
                    </h4>

                    <div class="mt-3 grid space-y-3 text-sm">
                        <p>
                            <a
                                class="inline-flex gap-x-2 text-gray-600 hover:text-gray-800"
                                :href="marketingPageUrls.termsOfService"
                            >
                                Terms of Service
                            </a>
                        </p>
                        <p>
                            <a
                                class="inline-flex gap-x-2 text-gray-600 hover:text-gray-800"
                                :href="marketingPageUrls.privacyPolicy"
                            >
                                Privacy Policy
                            </a>
                        </p>
                        <p>
                            <a
                                class="inline-flex gap-x-2 text-gray-600 hover:text-gray-800"
                                :href="marketingPageUrls.refundPolicy"
                            >
                                Refund Policy
                            </a>
                        </p>
                        <p>
                            <a
                                :id="openCookieSettingsElementId"
                                class="inline-flex gap-x-2 text-gray-600 hover:text-gray-800"
                                href="javascript:void(0)"
                            >
                                Cookie Preferences
                            </a>
                        </p>
                    </div>
                </div>
                <div class="col-span-2 lg:col-span-1">
                    <h4 class="text-xs font-semibold text-gray-900 uppercase">
                        Resources
                    </h4>

                    <div class="mt-3 grid space-y-3 text-sm">
                        <p>
                            <a
                                class="inline-flex gap-x-2 text-gray-600 hover:text-gray-800"
                                :href="marketingPageUrls.blogHomePageUrl"
                            >
                                Blog
                            </a>
                        </p>
                        <p>
                            <a
                                class="inline-flex gap-x-2 text-gray-600 hover:text-gray-800"
                                :href="
                                    marketingPageUrls.businessNameGeneratorUrl
                                "
                            >
                                Business Name Generator
                            </a>
                        </p>
                        <p>
                            <a
                                class="inline-flex gap-x-2 text-gray-600 hover:text-gray-800"
                                href="https://headwayapp.co/tinycal-changelog"
                                target="_blank"
                            >
                                Changelog
                            </a>
                        </p>
                        <p>
                            <a
                                class="inline-flex gap-x-2 text-gray-600 hover:text-gray-800"
                                href="https://tinycal.canny.io/feature-requests"
                                target="_blank"
                            >
                                Feature Requests
                            </a>
                        </p>
                        <p>
                            <a
                                class="inline-flex gap-x-2 text-gray-600 hover:text-gray-800"
                                :href="marketingPageUrls.zoomTutorial"
                            >
                                Zoom Tutorial
                            </a>
                        </p>
                    </div>
                </div>
            </div>

            <div class="pt-5">
                <div class="sm:flex sm:justify-between sm:items-center">
                    <div class="flex justify-between items-center"></div>
                </div>

                <div class="text-xs text-gray-500 mt-4">
                    <div>Google Calendar™ is a trademark of Google LLC.</div>
                    <div>Google Meet™ is a trademark of Google LLC.</div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup lang="ts">
    import Brand from './Brand.vue'
    import {
        RoutePathFreeToolEnum,
        RoutePathMarketingEnum,
    } from '@/Shared/AutoGenerated/RoutePathEnum'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'

    defineProps({
        appName: {
            type: String,
            required: true,
        },
        openCookieSettingsElementId: {
            type: String,
            required: true,
        },
    })

    const urlFactory = new UrlFactory()
    const marketingPageUrls = {
        flexibleAvailability: urlFactory.makeMarketingRoutePageUrl(
            RoutePathMarketingEnum.Feature_FlexibleAvailability,
        ),
        termsOfService: urlFactory.makeMarketingRoutePageUrl(
            RoutePathMarketingEnum.TermsOfService,
        ),
        privacyPolicy: urlFactory.makeMarketingRoutePageUrl(
            RoutePathMarketingEnum.PrivacyPolicy,
        ),
        refundPolicy: urlFactory.makeMarketingRoutePageUrl(
            RoutePathMarketingEnum.RefundPolicy,
        ),
        zoomTutorial: urlFactory.makeMarketingRoutePageUrl(
            RoutePathMarketingEnum.ZoomTutorial,
        ),
        blogHomePageUrl: urlFactory.makeBlogHomePageUrl(),
        businessNameGeneratorUrl: urlFactory.makeFreeToolRoutePageUrl(
            RoutePathFreeToolEnum.BusinessNameGenerator_StepStart,
        ),
    }
</script>
